export default __webpack_public_path__ + "static/media/NunitoSans-ExtraBoldItalic.33e33514.woff";